export const styles = {
  label: {
    '& .MuiFormLabel-asterisk': {
      color: 'error.D10',
    },
  },
  input: (theme) => ({
    '& .MuiInputBase-root': {
      pr: 1.5,
      '& .MuiInputAdornment-root.MuiInputAdornment-positionEnd': {
        mr: 0,
      },
      '& .MuiOutlinedInput-notchedOutline legend': {
        maxWidth: 'unset',
        ...theme.typography.label2,
        '> span': {
          p: '0 3px',
        },
      },
    },
    '& input[type=number]': {
      appearance: 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      appearance: 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      appearance: 'none',
      margin: 0,
    },
  }),
  clearIcon: {
    display: 'none',
    ['.MuiInputBase-root:hover &,' + ' .MuiInputBase-root.Mui-focused &']: {
      display: 'flex',
    },
  },
};
